module.exports = __webpack_public_path__ + "static/media/accept.7f2db258.svg";